<template>
  <v-card :class="['pre-schedule', { 'vertical': vertical }]" :level="2">
    <img class="pre-schedule__illustration"
      src="@/assets/img/widgets/clinical-staff/iconClinicalStaff.svg"
      alt="Pré agendamento ilustração"
      title="Pré agendamento ilustração" />
    <v-heading level="h3" weight="regular">Conheça nosso</v-heading>
    <v-heading level="h2" weight="heavy">Corpo clínico</v-heading>
    <p>Veja a equipe de médicos que estão em atividade tanto na matriz quanto no viValle
Ver corpo clínico</p>
    <div class="pre-schedule__actions">
      <v-btn :small="true" tag="router-link" to="/corpo-clinico" model="color-a">
        Ver corpo clínico
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import Card from '@/components/layout/Card.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Btn from '@/components/uikit/Btn.vue';
import PhoneNumber from '@/components/PhoneNumber.vue';

export default {
  name: 'SeeMedicalStaff',
  components: {
    'v-card': Card,
    'v-heading': Heading,
    'v-btn': Btn,
    'phone-number': PhoneNumber,
  },
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
$component: '.pre-schedule';

@mixin vertical-view {
  display: block;
  img {
    margin-bottom: $gutter-xxl;
  }
  #{$component}__actions {
    display: block;
    text-align: center;
    #{$component}__whatsaap {
      display: block;
      padding: 0;
      justify-content: center;
      span {
        display: block;
      }
    }
  }
  .btn {
    display: flex;
    margin-bottom: $gutter-l;
  }
}

#{$component} {
  display: grid;
  grid-template-columns: auto 170px;
  grid-template-rows: auto;
  background-color: $color-sys-k;
  border-radius: $border-radius;
  img {
    display: block;
    grid-column: 2 / 3;
    grid-row: 1 / 5;
    align-self: center;
    margin: auto;
  }
  h3 {
    grid-column: 1;
    grid-row: 1;
    margin: 0;
  }
  h2 {
    grid-column: 1;
    grid-row: 2;
    color: $color-a;
  }
  p {
    grid-column: 1;
    grid-row: 3;
    margin: 0;
    padding-right: $gutter-xxl;
    margin-bottom: $gutter-xxl;
    color: $color-sys-e;
    font-size: $font-size-xl;
  }
  &__actions {
    grid-column: 1 / 2;
    grid-row: 4;
    display: grid;
    grid-template-columns: 156px auto;
    grid-template-rows: auto;
    align-items: center;
    #{$component}__whatsaap {
      display: flex;
      flex-wrap: wrap;
      padding-left: $gutter-xxl;
      span {
        font-size: $font-size-l;
        font-weight: $font-weight-heavy;
        color: $color-a;
      }
      .phone {
        margin-left: $gutter-l;
      }
    }
  }
  @media screen and (max-width: #{$brakepoint-medium}) {
    @include vertical-view();
  }
  &.vertical {
    @include vertical-view();
  }
  .btn{
    width: 160px;
  }
}
</style>
